(function ($) {
    $('.EmailModal').appendTo("body");
}(window.jQuery));